<!--
 * @Description: 排号
 * @Author: zml
 * @Date: 2022-10-27 09:06:05
 * @LastEditors: zml
 * @LastEditTime: 2024-07-31 16:01:37
-->
<template>
  <div class="row-num">
    <el-carousel
      ref="carousel"
      :interval="8000"
      arrow="never"
      indicator-position="none"
      v-if="rowNumList.length>0"
      @mouseenter.native="delHandleMouseEnter"
    >
      <el-carousel-item v-for="(it,i) in newRowNumList" :key="i">
        <div :class="`card-box sortNum${ newRowNumList[0].length }`" v-for="(item,index) in it" :key="index">
          <div class="card">
            <div class="card-sort" :style="{background: setStyle.isOpenSet ? setStyle.bgColor : item.bg_color}">
              <div class="item">
                <div
                  class="next"
                  :style="setStyle.isOpenSet ? { color: setStyle.nextColor} : {}"
                  v-if="!item.stateName"
                >下一位：{{ item.arr_Next_Nu || '--' }}</div>
                <div class="now" :style="setStyle.isOpenSet ? { color: setStyle.currentNumColor} : {}">当前</div>
                <div class="num" :style="setStyle.isOpenSet ? { color: setStyle.currentNumColor} : {}">{{ item.stateName || item.arr_Nu}}</div>
                <div
                  class="date"
                  :style="setStyle.isOpenSet ? { color: setStyle.awaitTimeColor} : {}"
                  v-if="!item.stateName"
                >平均等待时长：{{item.waitingTime ===0 ? '--' : `${item.waitingTime} 分钟`}}</div>
              </div>
              <div class="card-sort-copy" v-if="item.stateName"></div>
            </div>
            <div class="card-room">洽谈室 {{ item.nego_Nu }}</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="marquee" v-else>
      <span class="marquee-txt" :style="setStyle.isOpenSet ? { color: setStyle.welcomeFontColor } : {}">{{configData.welcomeMessage}}</span>
    </div>
    <div class="footer">
      <div class="left" :style="setStyle.isOpenSet ? { color: setStyle.welcomeFontColor } : {}">洽谈室数：{{rowNumList.length}}</div>
      <div class="right">
        <span :style="setStyle.isOpenSet ? { color: setStyle.welcomeFontColor } : {}">{{configData.welcomeMessage}}，当前时间：{{formateTimeStamp(date)}}，</span>
        <span style="color:#a0d3ff;">宏升云</span>
        <span style="font-size:0.22rem;color:#A0D3FF">提供技术支持！</span>
      </div>
    </div>
    <el-dialog title="文字颜色设置" :visible.sync="dialogVisible" width="7rem" :show-close="false" center>
      <el-form ref="form" :model="form" label-width="130px" :rules="rules">
        <el-form-item label="启用设置：" prop="isOpenSet">
          <el-checkbox v-model="form.isOpenSet" label="启用"></el-checkbox>
        </el-form-item>
        <el-form-item label="下一位文字：" prop="nextFont">
          <div class="flex">
            <!-- <div style="width: 46px;">字号</div>
            <el-select style="width: 160px;" v-model="form.nextFont" placeholder="请选择">
              <el-option v-for="item in fontList" :key="item" :label="item" :value="item"></el-option>
            </el-select>-->
            <div style="width: 46px;">颜色</div>
            <el-color-picker v-model="form.nextColor"></el-color-picker>
          </div>
        </el-form-item>
        <el-form-item label="当前排号文字：" prop="currentNumber">
          <div class="flex">
            <!-- <div style="width: 46px;">字号</div>
            <el-select style="width: 160px;" v-model="form.currentNumFont" placeholder="请选择">
              <el-option v-for="item in fontList" :key="item" :label="item" :value="item"></el-option>
            </el-select>-->
            <div style="width: 46px;">颜色</div>
            <el-color-picker v-model="form.currentNumColor"></el-color-picker>
          </div>
        </el-form-item>
        <el-form-item label="等待时长文字：" prop="awaitTime">
          <div class="flex">
            <!-- <div style="width: 46px;">字号</div>
            <el-select style="width: 160px;" v-model="form.awaitTimeFont" placeholder="请选择">
              <el-option v-for="item in fontList" :key="item" :label="item" :value="item"></el-option>
            </el-select>-->
            <div style="width: 46px;">颜色</div>
            <el-color-picker v-model="form.awaitTimeColor"></el-color-picker>
          </div>
        </el-form-item>
        <el-form-item label="洽谈室背景：" prop="bgColor">
          <div class="flex">
            <div style="width: 46px;">颜色</div>
            <el-color-picker v-model="form.bgColor"></el-color-picker>
          </div>
        </el-form-item>
        <el-form-item label="欢迎语文字：" prop="welcomeFontColor">
          <div class="flex">
            <div style="width: 46px;">颜色</div>
            <el-color-picker v-model="form.welcomeFontColor"></el-color-picker>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveConfig">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  HallWorkGetList,
  HallWorkGetWorkConfig,
  HallWorkGetSpeakList,
  HallWorkDeleteSpeak
} from '@/api/home'
import { mapState } from 'vuex'
import * as SignalR from '@microsoft/signalr'
var socketTimer = null
export default {
  name: 'sortNum',

  data() {
    return {
      // 排号数据
      rowNumList: [],
      // 二维数组用于走马灯
      newRowNumList: [],
      // 欢迎语数据
      configData: {},
      dataList: [],
      connection: null,
      stopSpeak: false, // 停止播报
      repeatCount: 0, // 重复播报次数
      // 当前时间
      date: new Date().getTime(),
      path: 'ws://127.0.0.1:11999',
      socket: "",
      form: {
        isOpenSet: false,
        nextFont: '',
        nextColor: '',
        currentNumFont: '',
        currentNumColor: '',
        awaitTimeFont: '',
        awaitTimeColor: '',
        bgColor: '',
        welcomeFontColor: ''
      },
      setStyle: {},
      rules: {},
      dialogVisible: false,
      fontList: []
    }
  },
  created() {
    this.getList()
    this.loadTime()
    this.GetWorkConfig()


    this.fontList = []
    for (let i = 14; i <= 100; i++) {
      this.fontList.push(i)
    }
    let data = localStorage.getItem('sortNum_settings')
    if (data) {
      this.form = JSON.parse(data)
      this.setStyle = JSON.parse(JSON.stringify(this.form))
    }
  },
  mounted() {
    this.initSocket()
    this.initSignalR()
    const _this = this
    window.addEventListener('keydown', (e) => {
      if (e.key === 'F9' && e.ctrlKey) {
        _this.dialogVisible = false
        _this.openDialog()
      }
    })
  },
  destroyed() {
    window.removeEventListener('keydown', () => { })
    this.socket = ''
    if (socketTimer) {
      clearInterval(socketTimer)
    }
  },
  computed: {
    ...mapState('tenant', ['tenantInfo'])
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
      let data = localStorage.getItem('sortNum_settings')
      if (data) {
        data = JSON.parse(data)
        this.form = data
      }
    },
    saveConfig() {
      this.dialogVisible = false
      this.setStyle = JSON.parse(JSON.stringify(this.form))
      this.$message.success('保存配置成功')
      localStorage.setItem('sortNum_settings', JSON.stringify(this.form))
    },
    initSocket() {
      if (typeof (WebSocket) === 'undefined') {
        this.$message.warning('您的浏览器不支持socket，将无法使用语音播报功能')
      } else {
        this.socket = new WebSocket(this.path)
        // 打开socket
        this.socket.onopen = () => {
          this.getSpeakList()
          this.heartCheck()
        }
        // 连接错误
        this.socket.onerror = () => {
          const _this = this
          // 清除心跳检测
          if (socketTimer) {
            clearInterval(socketTimer)
          }

          setTimeout(() => {
            _this.initSocket()
          }, 5000)
        }
        // 监听消息
        this.socket.onmessage = (res) => {
          if (res.data === 'ok') {
            if (this.dataList.length > 0) {
              if (this.repeatCount < 2) {
                this.speakText(this.dataList)
              } else {
                HallWorkDeleteSpeak({ id: this.dataList[0].id }).then(res => {
                  if (res.success) {
                    this.dataList.splice(0, 1)
                    if (this.dataList.length > 0) {
                      this.repeatCount = 0
                      this.speakText(this.dataList)
                    } else {
                      if (this.stopSpeak) {
                        this.getSpeakList()
                      }
                    }
                  }
                })
              }
            }
          }
        }
      }
    },

    // socket心跳检测
    heartCheck() {
      if (socketTimer) {
        clearInterval(socketTimer)
      }

      const _this = this
      socketTimer = setInterval(() => {
        if (_this.socket.readyState !== 1) {
          _this.initSocket()
        }
      }, 3000)
    },

    // 初始化SignalR
    initSignalR() {
      const tenantId = this.tenantInfo.id
      if (!this.connection) {
        this.connection = new SignalR.HubConnectionBuilder()
          .withUrl(process.env.VUE_APP_API_BASE_URL + '/exhibitonhub/screen', {
            accessTokenFactory: () => tenantId,
            skipNegotiation: true,
            transport: SignalR.HttpTransportType.WebSockets
          })
          .withAutomaticReconnect()
          .build()

        this.connection.on('SendNotice', data => {
          // 0：排号  1：播报语音
          switch (data.cateroy) {
            case 0:
              this.getList()
              break
            case 1:
              this.stopSpeak = true
              if (this.dataList.length === 0) {
                this.getSpeakList()
              }
              break
          }
          console.log('推送成功', data)
        })

        this.connection.start()

        this.connection.onclose(async () => {
          console.log('断开')
        })
      }
    },

    // 获取排号数据
    getList() {
      HallWorkGetList().then(res => {
        if (res.success) {
          this.rowNumList = res.data
          this.rowNumList.sort((a, b) => {
            return a.nego_Nu - b.nego_Nu
          }) // 排序

          this.rowNumList = res.data.map((item, index) => {
            if (index == 0 || (index + 1) % 5 === 1) {
              return {
                ...item,
                bg_color:
                  'linear-gradient(180deg, #9b92e1, #65bde1 99%, #65bde1)'
              }
            } else if (index == 1 || (index + 1) % 5 === 2) {
              return {
                ...item,
                bg_color:
                  'linear-gradient(180deg,#eb7773, #ee8f64 99%, #ee8f64)'
              }
            } else if (index == 2 || (index + 1) % 5 === 3) {
              return {
                ...item,
                bg_color:
                  'linear-gradient(180deg,#9f8bed, #afa0f0 99%, #afa0f0)'
              }
            } else if (index == 3 || (index + 1) % 5 === 4) {
              return {
                ...item,
                bg_color:
                  'linear-gradient(180deg,#5c82f7, #7493f6 99%, #7493f6)'
              }
            } else if (index == 4 || (index + 1) % 5 === 0) {
              return {
                ...item,
                bg_color:
                  'linear-gradient(180deg,#82d8bf, #94deca 99%, #94deca)'
              }
            } else {
              return {
                ...item,
                bg_color:
                  'linear-gradient(180deg,#eb7773, #ee8f64 99%, #ee8f64)'
              }
            }
          })
          this.newRowNumList = []
          let index = 0
          while (index < this.rowNumList.length) {
            this.newRowNumList.push(this.rowNumList.slice(index, (index += 12)))
          }
        }
      })
    },
    // 获取要播报的内容列表
    getSpeakList() {
      HallWorkGetSpeakList().then(res => {
        if (res.success) {
          this.dataList = res.data || []
          if (this.dataList.length > 0) {
            this.stopSpeak = false
            this.repeatCount = 0
            const _this = this
            setTimeout(() => {
              _this.speakText(res.data)
            }, 500)
          }
        }
      })
    },
    speakText(data) {
      this.repeatCount++
      console.log(data[0].str_Speak)
      const speakMessage = data[0].str_Speak
        .replaceAll('0', ' 0 ')
        .replaceAll('1', ' 1 ')
        .replaceAll('2', ' 2 ')
        .replaceAll('3', ' 3 ')
        .replaceAll('4', ' 4 ')
        .replaceAll('5', ' 5 ')
        .replaceAll('6', ' 6 ')
        .replaceAll('7', ' 7 ')
        .replaceAll('8', ' 8 ')
        .replaceAll('9', ' 9 ')
        .replaceAll('-', ' 杠 ')
        .replaceAll('_', ' 杠 ')

      const objData = {
        type: 1,
        message: speakMessage
      }
      this.socket.send(JSON.stringify(objData))
    },

    // 获取欢迎语配置信息
    GetWorkConfig() {
      HallWorkGetWorkConfig().then(res => {
        if (res.success) {
          this.configData = res.data
        }
      })
    },

    // 阻止鼠标移入停止滚动
    delHandleMouseEnter() {
      this.$refs.carousel.handleMouseEnter = () => { }
    },

    // 获取实时时间
    loadTime() {
      var _this = this
      setInterval(() => {
        _this.date += 1000
      }, 1000)
    },
    // 转换时间戳
    formateTimeStamp(time) {
      var date = new Date(time)
      var year = date.getFullYear()
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minute =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var second =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      var week = ['日', '一', '二', '三', '四', '五', '六'][date.getDay()]
      return (
        year +
        '年' +
        month +
        '月' +
        day +
        '日 ' +
        ' 星期' +
        week +
        ' ' +
        hour +
        ':' +
        minute +
        ':' +
        second
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.row-num {
  height: 100vh;
  background: #282e46;

  :deep .el-carousel {
    height: 100%;

    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__item {
      width: 100%;
      height: calc(100% - 1rem);
      display: flex;
      align-content: flex-start;
      flex-wrap: wrap;
      padding: 0.2rem 0 0.2rem 0.2rem;
      box-sizing: border-box;
      background: #282e46;
      .card-box {
        width: 25%;
        // height: 3rem;
        // height: 2.82rem;
        height: 32%;
        padding: 0 0.2rem 0 0;
        margin-bottom: 0.2rem;
        box-sizing: border-box;
        font-family: MicrosoftYaHei;
        .card {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: 100%;
          border-radius: 0.1rem;
          overflow: hidden;
          .card-sort-copy {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: #666;
            opacity: 0.6;
          }
          .card-sort {
            position: relative;
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            color: #ffffff;

            .item {
              position: absolute;
              z-index: 10;
              position: relative;
              flex: 1;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              width: 100%;
              color: #ffffff;
            }
            .next {
              width: 2rem;
              height: 0.36rem;
              text-align: center;
              line-height: 0.36rem;
              font-size: 0.2rem;
              margin: 0.2rem 0 0 0;
              background: rgba(255, 255, 255, 0.2);
              border: 1px solid rgba(255, 255, 255, 0.5);
              border-radius: 0.19rem;
            }
            .now {
              font-size: 0.25rem;
              margin: 0.1rem 0 0 0;
            }

            .num {
              font-size: 0.45rem;
              font-weight: bold;
            }
            .date {
              font-size: 0.25rem;
              height: 0.26rem;
              color: #f5f5f5;
              letter-spacing: 0.01rem;
              margin: 0.1rem 0 0.02rem 0;
            }
          }
          .card-room {
            width: 100%;
            height: 0.6rem;
            line-height: 0.6rem;
            text-align: center;
            background: #fbfcff;
            font-weight: bold;
            color: #222222;
            font-size: 0.24rem;
          }
        }
      }
    }
  }
  .marquee {
    width: 100%;
    height: 88vh;
    font-size: 1.6rem;
    line-height: 88vh;

    box-sizing: border-box;
    word-break: break-all;
    white-space: nowrap;
    overflow: hidden;
    color: #fff;

    .marquee-txt {
      display: inline-block;
      padding-left: 100%; /* 从右至左开始滚动 */
      animation: marqueeTransform 16s linear infinite;
    }
    @keyframes marqueeTransform {
      0% {
        transform: translate(0, 0);
      }
      100% {
        transform: translate(-100%, 0);
      }
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;

    height: 0.9rem;
    // height: 9%;
    z-index: 99;
    background: #333955;
    padding: 0 0.4rem;
    font-size: 0.3rem;
    color: #ffffff;

    .left {
      font-family: MicrosoftYaHei;
      letter-spacing: 0.03rem;
    }
  }
}

.sortNum1 {
  width: 100% !important;
  height: 100% !important;
  .card {
    .card-sort {
      .next {
        width: 8rem !important;
        height: 1rem !important;
        line-height: 1rem !important;
        font-size: 0.6rem !important;
        margin: 0.2rem 0 0 0 !important;
        border-radius: 0.5rem !important;
      }
      .now {
        font-size: 0.6rem !important;
        margin: 0.4rem 0 0 0 !important;
      }

      .num {
        font-size: 1rem !important;
        font-weight: bold;
      }
      .date {
        font-size: 0.6rem !important;
        height: 0.26rem;
        color: #f5f5f5;
        letter-spacing: 0.02rem !important;
        margin: 0.3rem 0 0.04rem 0 !important;
      }
    }
    .card-room {
      width: 100%;
      height: 1.5rem !important;
      line-height: 1.5rem !important;
      font-size: 0.8rem !important;
      font-weight: bold;
    }
  }
}

.sortNum2 {
  width: 50% !important;
  height: 100% !important;
  .card {
    .card-sort {
      .next {
        width: 6rem !important;
        height: 1rem !important;
        line-height: 1rem !important;
        font-size: 0.6rem !important;
        margin: 0.2rem 0 0 0 !important;
        border-radius: 0.5rem !important;
      }
      .now {
        font-size: 0.6rem !important;
        margin: 0.4rem 0 0 0 !important;
      }

      .num {
        font-size: 1rem !important;
        font-weight: bold;
      }
      .date {
        font-size: 0.6rem !important;
        height: 0.26rem;
        color: #f5f5f5;
        letter-spacing: 0.02rem !important;
        margin: 0.3rem 0 0.04rem 0 !important;
      }
    }
    .card-room {
      width: 100%;
      height: 1.5rem !important;
      line-height: 1.5rem !important;
      font-size: 0.8rem !important;
      font-weight: bold;
    }
  }
}

.sortNum3,
.sortNum4 {
  width: 50% !important;
  height: 49% !important;
  .card {
    .card-sort {
      .next {
        width: 4rem !important;
        height: 0.5rem !important;
        line-height: 0.5rem !important;
        font-size: 0.3rem !important;
        margin: 0.2rem 0 0 0 !important;
        border-radius: 0.5rem !important;
      }
      .now {
        font-size: 0.3rem !important;
        margin: 0.2rem 0 0 0 !important;
      }

      .num {
        font-size: 0.5rem !important;
        font-weight: bold;
      }
      .date {
        font-size: 0.3rem !important;
        height: 0.26rem !important;
        color: #f5f5f5;
        letter-spacing: 0.02rem !important;
        margin: 0.3rem 0 0.04rem 0 !important;
      }
    }
    .card-room {
      width: 100%;
      height: 0.8rem !important;
      line-height: 0.8rem !important;
      font-size: 0.4rem !important;
      font-weight: bold;
    }
  }
}

.sortNum5,
.sortNum6 {
  width: 33.33% !important;
  height: 49% !important;
  .card {
    .card-sort {
      .next {
        width: 4rem !important;
        height: 0.5rem !important;
        line-height: 0.5rem !important;
        font-size: 0.3rem !important;
        margin: 0.2rem 0 0 0 !important;
        border-radius: 0.5rem !important;
      }
      .now {
        font-size: 0.3rem !important;
        margin: 0.2rem 0 0 0 !important;
      }

      .num {
        font-size: 0.5rem !important;
        font-weight: bold;
      }
      .date {
        font-size: 0.3rem !important;
        height: 0.26rem !important;
        color: #f5f5f5;
        letter-spacing: 0.02rem !important;
        margin: 0.3rem 0 0.04rem 0 !important;
      }
    }
    .card-room {
      width: 100%;
      height: 0.8rem !important;
      line-height: 0.8rem !important;
      font-size: 0.4rem !important;
      font-weight: bold;
    }
  }
}
.sortNum7,
.sortNum8 {
  width: 25% !important;
  height: 49% !important;
  .card {
    .card-sort {
      .next {
        width: 3rem !important;
        height: 0.5rem !important;
        line-height: 0.5rem !important;
        font-size: 0.3rem !important;
        margin: 0.2rem 0 0 0 !important;
        border-radius: 0.5rem !important;
      }
      .now {
        font-size: 0.3rem !important;
        margin: 0.2rem 0 0 0 !important;
      }

      .num {
        font-size: 0.5rem !important;
        font-weight: bold;
      }
      .date {
        font-size: 0.3rem !important;
        height: 0.26rem !important;
        color: #f5f5f5;
        letter-spacing: 0.02rem !important;
        margin: 0.3rem 0 0.04rem 0 !important;
      }
    }
    .card-room {
      width: 100%;
      height: 0.8rem !important;
      line-height: 0.8rem !important;
      font-size: 0.4rem !important;
      font-weight: bold;
    }
  }
}

.sortNum9 {
  width: 33.33% !important;
  height: 32% !important;
}

.sortNum10,
.sortNum11,
.sortNum12 {
  width: 25% !important;
  height: 32% !important;
}

.flex {
  display: flex;
}

.el-form-item {
  display: flex;
  :deep .el-form-item__content {
    margin-left: 0 !important;
    .el-color-picker__trigger {
      width: 200px;
    }
  }
}
</style>